import { DxContainer, DxGrid, DxSpacer } from '@dvag/design-system-react';

import { useParams } from 'react-router-dom';
import { usePersonList } from 'hooks/usePersonList';
import { PersonInHouseholdDto } from 'graphql/generates';

import { WishAndGoalSalesforceContent } from './WishAndGoalSalesforceContent';

export const WishAndGoalSalesforce = () => {
  const { personId: paramPersonId } = useParams();
  const { data: personList, isFetched } = usePersonList({ isSalesforce: true });

  const getSortedPersonList = () =>
    [...personList].sort((a: PersonInHouseholdDto, b: PersonInHouseholdDto) => {
      const dateA = a.birthDate ? new Date(a.birthDate).getTime() : null;
      const dateB = b.birthDate ? new Date(b.birthDate).getTime() : null;

      if (!dateA && !dateB) {
        return 0;
      }
      if (!dateA) {
        return 1;
      }
      if (!dateB) {
        return -1;
      }

      return dateA - dateB;
    });

  const wgPersonList = paramPersonId
    ? personList.filter((i: PersonInHouseholdDto) => i.id === paramPersonId)
    : getSortedPersonList().slice(0, 2);

  const mqGrid = paramPersonId || personList.length === 1 ? '12/*' : '6-6/*';

  if (isFetched && !wgPersonList.length) {
    throw Error('Not Found', { cause: 404 });
  }

  return (
    <DxContainer color="transparent" data-testid="wg-salesforce-page-container" type="page">
      <DxSpacer size="16v" />
      <DxGrid mq2="12/*" mq3={mqGrid} data-testid="wg-salesforce-page-grid">
        {wgPersonList.map((person: PersonInHouseholdDto) => (
          <WishAndGoalSalesforceContent key={person.id} person={person} />
        ))}
      </DxGrid>
      <DxSpacer size="16v" />
    </DxContainer>
  );
};
